import { fetchApi } from './client'
import type { Organization, Phenotype } from './types'

/**
 * Fetch list of organizations from Rails API.
 */
export async function getOrganizations(): Promise<Organization[]> {
  try {
    const response = await fetchApi<{ organizations: Organization[] }>('/api/v1/phenotypes/organizations')
    return response.organizations || []
  } catch (error) {
    console.warn('Organizations endpoint not available:', error)
    return []
  }
}

/**
 * Fetch list of all phenotypes, optionally filtered by organization.
 */
export async function getPhenotypes(orgId?: string): Promise<Phenotype[]> {
  try {
    const params = orgId ? `?orgId=${encodeURIComponent(orgId)}` : ''
    const response = await fetchApi<{ phenotypes: Phenotype[] }>(`/api/v1/phenotypes${params}`)
    return response.phenotypes || []
  } catch (error) {
    console.warn('Phenotypes endpoint not available:', error)
    return []
  }
}

/**
 * Fetch single phenotype by ID.
 */
export async function getPhenotype(id: string, orgId?: string): Promise<Phenotype | null> {
  try {
    const params = orgId ? `?orgId=${encodeURIComponent(orgId)}` : ''
    return await fetchApi<Phenotype>(`/api/v1/phenotypes/${id}${params}`)
  } catch {
    return null
  }
}
